// @flow

export const SqlTokenSymbol = Symbol('SLONIK_SQL');
export const RawSqlTokenSymbol = Symbol('SLONIK_RAW_SQL');
export const IdentifierTokenSymbol = Symbol('SLONIK_IDENTIFIER');
export const ValueListTokenSymbol = Symbol('SLONIK_VALUE_LIST');
export const TupleTokenSymbol = Symbol('SLONIK_TUPLE');
export const TupleListTokenSymbol = Symbol('SLONIK_TUPLE_LIST');
export const UnnestTokenSymbol = Symbol('SLONIK_UNNEST');
